<template>
  <div class="news-list-content">
    <div class="top-header-content">
      <div class="align-center">
        <img src="@/assets/images/website/home/iconHome.svg" @click="toHome" />
        <span class="home" @click="toHome">首页</span>
        <span class="home"> ></span><span class="dow" @click="$router.push(path)">资讯列表</span>
      </div>
    </div>
    <div class="content-top">
      <div class="topbox">
        <el-carousel height="390px" class="newcarousel" v-if="topNewsList && topNewsList.length > 0">
          <el-carousel-item v-for="item in topNewsList" :key="item.sectionId">
            <div class="flex" @click="$router.push('/aboutNewsdetail?id=' + item.id)">
              <img referrerpolicy='no-referrer' :src="item.coverUrl" />
              <div class="rightBox">
                <p class="title">
                  {{ getTime(item.issueTime)
                  }}<span>/{{ getDay(item.issueTime) }}</span>
                </p>
                <p class="text text-overflow-ellipsis-2">{{ item.title }}</p>
                <p class="context text-overflow-ellipsis-3">
                  {{ item.introduction }}
                </p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <el-tabs v-model="activeName" @tab-click="handleClick" class="tabsbox">
          <el-tab-pane label="全部" name="0"></el-tab-pane>
          <el-tab-pane :label="type.name" :name="type.code" v-for="type in TypeList" :key="type.id"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="aboutNewsbox" v-if="aboutNewsList && aboutNewsList.length > 0">
      <div class="tabitembox flex flex-wrap">
        <div class="item-content" v-for="(item, index) in aboutNewsList" :key="index"
          @click="$router.push('/aboutNewsdetail?id=' + item.id)">
          <div class="img-content">
            <img referrerpolicy='no-referrer' class="img-style" :src="item.coverUrl" />
            <div class="title-text text-overflow-ellipsis-2" :title="item.title">{{ item.title }}</div>
          </div>
          <div class="info-content">
            <div class="introduction-content text-overflow-ellipsis-2" :title="item.introduction">{{ item.introduction }}
            </div>
            <div class="info-date">{{ item.issueTime }}</div>
          </div>
        </div>
      </div>
      <pagination :handleSizeChange="handleSizeChange" :handleCurrentChange="handleCurrentChange"
        :currPage="queryParams.current" :pageSize="queryParams.pageSize" :total="total" />
    </div>
    <empty-page class="news-empty-content" text="该分类暂无数据" v-else></empty-page>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import { getHomeInformationList, getTopList, getDictsByDictCategoryCodeList } from "@/api/index.js"
import EmptyPage from "@/components/emptyPage/index.vue"
export default {
  components: { pagination, EmptyPage },
  data() {
    return {
      activeName: null,
      newsList: [],
      TypeList: [],
      aboutNewsList: [],
      queryParams: {
        current: 1,
        pageSize: 9,
        type: null,
        isTop: 0,
      },
      total: 0,
      topNewsList: null,
      first: true,
    };
  },
  mounted() {
    this.getTopList();
    this.informationgetType();
    this.informationgetlist();
    document.documentElement.scrollTop = 0
  },
  methods: {
    getType(type) {
      if (type) {
        let list = this.TypeList.filter((i) => i.code == type);
        return list.length > 0 ? list[0].name : null;
      }
      return null;
    },
    getTime(date) {
      if (date) {
        let timestr = date.split(" ")[0].split("-");
        return `${timestr[1]}-${timestr[2]}`;
      }
      return;
    },
    getDay(date) {
      if (date) {
        let timestr = date.split(" ")[0];
        return `${timestr.split("-")[0]}`;
      }
      return;
    },
    toHome() {
      if (window.DOMAIN_CONFIG.newuser) {
        window.location.href = `${window.DOMAIN_CONFIG.newuser}`
      } else {
        this.$router.push('/home')
      }
    },
    async informationgetlist() {
      let { data } = await getHomeInformationList(this.queryParams);
      this.aboutNewsList = data.list;
      this.total = data.pagination.total;
    },

    async informationgetType() {
      let { data } = await getDictsByDictCategoryCodeList({
        fieldCode: "basic",
        dictCategoryCode: "information_type",
      });
      this.TypeList = data.information_type;
    },
    async getTopList() {
      let { data } = await getTopList();
      this.topNewsList = data;
    },
    handleClick() {
      this.queryParams.current = 1;
      this.queryParams.type = this.activeName == "0" ? null : this.activeName;
      this.informationgetlist();
    },
    // 分页组件
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.queryParams.current = 1;
      this.informationgetlist();
    },
    handleCurrentChange(val) {
      this.queryParams.current = val;
      this.informationgetlist();
    },
  },
};
</script>

<style lang="less" scoped>
@width: 1268px;

.news-list-content {
  padding-bottom: 39px;
  background: #ffffff;

  .top-header-content {
    width: @width;
    padding: 27px 0 25px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    line-height: 19px;
    margin: 0 auto;

    img {
      height: 15px;
      margin-right: 5px;
      cursor: pointer;
    }

    .home {
      padding-right: 5px;
      color: #333333;
      cursor: pointer;
    }

    .dow {
      display: inline-block;
      max-width: 1000px;
      padding-left: 5px;
      color: #999999;
    }
  }

  .content-top {
    padding-top: 20px;
    background: #f3f3f4;
    box-shadow: 0px 1px 0px 0px #ececec;

    .topbox {
      width: @width;
      margin: 0 auto;
    }

    .newcarousel {
      cursor: pointer;

      img {
        width: 50%;
        height: 390px;
      }

      .rightBox {
        width: 50%;
        padding: 50px 20px 105px 50px;
        background: #ffffff;

        .title {
          font-size: 30px;
          font-family: Arial-BoldMT, Arial;
          font-weight: normal;
          color: #0a1325;
          line-height: 34px;

          span {
            font-size: 14px;
            line-height: 16px;
          }
        }

        .text {
          margin: 18px 0 16px;
          font-size: 26px;
          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
          font-weight: bold;
          color: #000000;
          line-height: 35px;
        }

        .context {
          font-size: 16px;
          font-family: MicrosoftYaHei;
          color: #999999;
          line-height: 26px;
        }
      }
    }

    .tabsbox {
      margin-left: 20px;
      margin-top: 74px;
    }
  }

  .aboutNewsbox {
    width: @width;
    margin: 1px auto 0;

    .tabitembox {
      padding-bottom: 40px;

      .item-content {
        margin-right: 16px;
        margin-bottom: 20px;
        box-shadow: 0px 10px 30px 0px rgba(122, 127, 131, 0.13);
        border: 1px solid #F2F6FA;
        cursor: pointer;

        .img-content {
          width: 410px;
          height: 264px;
          position: relative;

          .img-style {
            width: 410px;
            height: 264px;
          }

          .title-text {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 410px;
            height: 70px;
            padding: 10px 12px;
            background: rgba(0, 0, 0, 0.6);
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            line-height: 28px;
          }
        }

        .info-content {
          width: 410px;
          padding: 18px 20px;
          font-size: 14px;
          font-weight: 400;
          color: #354052;

          .introduction-content {
            margin-bottom: 10px;
            height: 52px;
            line-height: 25px;
          }

          .info-date {
            color: #8291A9;
          }
        }
      }

      .item-content:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}

.news-empty-content {
  width: @width;
  margin: 0 auto;
  background: #fff;
}
</style>
<style lang="less">
.tabsbox {
  .el-tabs__nav-wrap::after {
    display: none;
  }

  .el-tabs__item {
    padding: 0 40px;
    font-size: 20px;
    font-family: MicrosoftYaHei;
    color: #000000;
    line-height: 40px;
  }

  .el-tabs__active-bar {
    height: 4px;
    background: #005fe1;
  }

  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    font-size: 30px;
  }

  .el-tabs__nav-wrap.is-scrollable {
    padding: 0 40px;
  }
}

.newcarousel {
  .el-carousel__indicators--horizontal {
    left: 970px;
    bottom: 90px;
  }

  .el-carousel__button {
    background-color: #c2c2c2;
    width: 8px;
    height: 8px;
    border-radius: 100%;
  }

  .el-carousel__indicator.is-active button {
    opacity: 1;
    background: #005fe1;
  }
}
</style>
